import { render, staticRenderFns } from "./AsignacionPerfiles.vue?vue&type=template&id=4bbf1855&scoped=true&"
import script from "./AsignacionPerfiles.vue?vue&type=script&lang=js&"
export * from "./AsignacionPerfiles.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AsignacionPerfiles.vue?vue&type=style&index=1&id=4bbf1855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf1855",
  null
  
)

export default component.exports